// extracted by mini-css-extract-plugin
export default {"status":"StatusGridCell_status__B8524"};